// コレクションページのクイック追加フォームを非表示
// 会社概要ページの画像センター寄せ
(function() {
  var style = document.createElement('style');
  style.textContent = '.product-item__quick-form { display: none !important; } .rte img, .page-content img { display: inline !important; margin-left: auto; margin-right: auto; }';
  document.head.appendChild(style);
})();
